/* eslint-disable */
/* eslint-disable jsx-control-statements/jsx-use-if-tag */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
  Grid,
  TextField,
  MenuItem,
  Select,
  TextareaAutosize,
} from '@mui/material';
import { Box } from '@mui/system';
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { generatePDF } from '../../utils';
import { CircularProgress } from '@mui/material';
import { Close } from '@mui/icons-material';

const initialState = {
  name: '',
  shipping_add: '',
  mail_id: '',
  comment: '',
  state: '',
  city: '',
  postal_code: '',
  phone_number: '',
  survey: '',
  survey_details: '',
};

const RequestQuote = ({ parentPath }) => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState(initialState);
  const [error, setError] = useState({});
  const [submit, setSubmit] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [surveyOption, setSurveyOption] = useState('');

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const controller = useMemo(() => new AbortController(), [open]);
  const signal = controller.signal;

  // Breakpoints for PDF Generation
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up('lg'));
  const tablet = useMediaQuery(theme.breakpoints.up('sm'));
  const mobile = useMediaQuery(theme.breakpoints.up('xs'));

  const sizes = () => {
    if (desktop) return [-140, -670];
    if (tablet) return [-140, -670];
    if (mobile) return [-170, -1300];
  };

  // END

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    controller.abort();
    setOpen(false);
    setFormData(initialState);
    setError({});
    setTimeout(() => {
      setSubmit(false);
      setIsSubmitting(false);
    }, 500);
    setSurveyOption('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const fields = { ...formData };
    delete fields.comment;
    let errObj = {};

    for (const field of Object.keys(fields)) {
      const target = {
        target: { id: field, value: formData?.[field] },
      };
      const err = handleError(target);
      errObj = { ...errObj, ...err };
    }
    if (Object.keys(errObj)?.length === 0) {
      setIsSubmitting(true);
      generatePDF(parentPath, 'blob', sizes).then(async (datauristring) => {
        try {
          const pdfURI = datauristring.replace(
            'data:application/pdf;filename=generated.pdf;base64,',
            '',
          );
          const rawResponse = await fetch(
            `${window.location.protocol}//${window.location.host}/wp-json/quote/request_quote`,
            // 'https://staging.elmirastoveworks.com/wp-json/quote/request_quote',
            {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
              signal,
              body: JSON.stringify({ userData: formData, pdfURI }),
            },
          );
          const response = await rawResponse.json();

          if (response !== 'Ok') {
            console.log('error', error);
            alert('An error occurred. Please try again later.');
          } else {
            setSubmit(true);
          }
          setIsSubmitting(false);
        } catch (error) {
          console.log('error', error);
          setIsSubmitting(false);
          if (error.name !== 'AbortError') {
            alert('An error occurred. Please try again later.');
            handleClose();
          }
        }
      });
    }
  };

  const handleChange = (e) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        [e.target.id || e.target.name]: e.target.value,
      };
    });
    if (
      e.target.value == 'Online Ad' ||
      e.target.value == 'Friend or Acquaintance'
    ) {
      setFormData((prevState) => {
        return {
          ...prevState,
          survey_details: 'N/A',
        };
      });
    }

    if (e.target.name == 'survey') {
      setSurveyOption(e.target.value);
      if (formData.survey_details == 'N/A') {
        setFormData((prevState) => {
          return {
            ...prevState,
            survey_details: '',
          };
        });
      }
    }

    if (error?.[e.target.id] || error?.[e.target.name]) {
      const state = { ...error };
      delete state?.[e.target.id];
      delete state?.[e.target.name];
      setError({ ...state });
    }
  };

  const handleError = (e) => {
    const emailValidation = /^[\w-.]+@([\w-]+.)+[\w-]{2,4}$/;
    const numberValidation = /^[0-9\b]+$/;
    const characterValidation = /^[ a-zA-Z0-9-&.]+$/;

    let err = {};
    if (!e.target.value) {
      err = {
        [e.target.id || e.target.name]: 'Required',
      };

      setError((prevState) => {
        return {
          ...prevState,
          [e.target.id || e.target.name]: 'Required',
        };
      });
    } else if (
      e.target.id === 'mail_id' &&
      !emailValidation.test(e.target.value)
    ) {
      err = {
        [e.target.id]: 'Required',
      };
      setError((prevState) => {
        return {
          ...prevState,
          [e.target.id]: 'Invalid Email address',
        };
      });
    } else if (
      (e.target.id === 'city' ||
        e.target.id === 'state' ||
        e.target.name == 'survey_details') &&
      !characterValidation.test(e.target.value)
    ) {
      err = {
        [e.target.id || e.target.name]: 'Required',
      };
      setError((prevState) => {
        return {
          ...prevState,
          [e.target.id]: 'Invalid character',
        };
      });
    } else if (
      e.target.id === 'phone_number' &&
      !numberValidation.test(e.target.value)
    ) {
      err = {
        [e.target.id]: 'Required',
      };
      setError((prevState) => {
        return {
          ...prevState,
          [e.target.id]: 'Invalid',
        };
      });
    }
    return err;
  };

  const showError = (id) => {
    const err = error?.[id];

    if (err) {
      return <span style={{ color: 'red', fontSize: '12px' }}>{err}</span>;
    }
  };

  return (
    <>
      <Box onClick={handleClickOpen} className="PricingTotalInfo WaterBlueBg">
        <Typography variant="h3" textAlign="center">
          CONTACT US FOR YOUR TOTAL COST
        </Typography>
        <Typography variant="body2" textAlign="center">
          (Elmira appliances plus freight, delivery, and applicable taxes)
        </Typography>
      </Box>
      <Dialog
        open={open}
        onClose={() => false}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="QuoteFormDialog"
        fullWidth={true}
        maxWidth={'md'}
      >
        <form onSubmit={handleSubmit}>
          <DialogTitle textAlign={'center'} id="alert-dialog-title">
            {!submit ? 'Request Quote' : 'Thank you!'}
            {!submit && (
              <IconButton
                aria-label="close"
                onClick={handleClose}
                className="CloseButton"
              >
                <Close />
              </IconButton>
            )}
          </DialogTitle>
          <DialogContent>
            {!submit ? (
              <Box component="div" className="QuoteFormBox">
                {isSubmitting ? (
                  <Box
                    sx={{
                      mt: 20,
                      mb: 20,
                      textAlign: 'center',
                    }}
                  >
                    <CircularProgress color="secondary" />
                  </Box>
                ) : (
                  <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    spacing={3}
                  >
                    <Grid item xs={12} md={6}>
                      <label>
                        Name<sup>*</sup>
                      </label>
                      <TextField
                        type="text"
                        name="name"
                        id="name"
                        onChange={handleChange}
                        onBlur={handleError}
                        className="quote_re_form"
                      />
                      {showError('name')}
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label>
                        Email address<sup>*</sup>
                      </label>
                      <TextField
                        type="email"
                        className="quote_re_form"
                        name="mail_id"
                        id="mail_id"
                        onChange={handleChange}
                        onBlur={handleError}
                      />
                      {showError('mail_id')}
                    </Grid>
                    <Grid item xs={12} className="FullwidthFLD">
                      <label>
                        Shipping address<sup>*</sup>
                      </label>
                      <TextField
                        type="text"
                        className="quote_re_form"
                        name="shipping_add"
                        id="shipping_add"
                        onChange={handleChange}
                        onBlur={handleError}
                      />
                      {showError('shipping_add')}
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label>
                        City<sup>*</sup>
                      </label>
                      <TextField
                        type="text"
                        className="quote_re_form"
                        name="city"
                        id="city"
                        onChange={handleChange}
                        onBlur={handleError}
                      />
                      {showError('city')}
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label>
                        State/Province<sup>*</sup>
                      </label>
                      <TextField
                        type="text"
                        className="quote_re_form"
                        name="state"
                        id="state"
                        onChange={handleChange}
                        onBlur={handleError}
                      />
                      {showError('state')}
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label>
                        ZIP/Postal Code<sup>*</sup>
                      </label>
                      <TextField
                        type="text"
                        className="quote_re_form"
                        name="postal_code"
                        id="postal_code"
                        onChange={handleChange}
                        onBlur={handleError}
                      />
                      {showError('postal_code')}
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label>
                        Phone Number<sup>*</sup>
                      </label>
                      <TextField
                        type="text"
                        className="quote_re_form"
                        name="phone_number"
                        id="phone_number"
                        onChange={handleChange}
                        onBlur={handleError}
                      />
                      {showError('phone_number')}
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label>
                        How did you find us?<sup>*</sup>
                      </label>
                      <Select
                        fullWidth
                        id="survey"
                        name="survey"
                        className="quote_re_form"
                        onChange={handleChange}
                        onBlur={handleError}
                      >
                        <MenuItem selected disabled hidden>
                          Please select one
                        </MenuItem>
                        <MenuItem value="Online Search">Online Search</MenuItem>
                        <MenuItem value="Online Ad">Online Ad</MenuItem>
                        <MenuItem value="Magazine Ad">Magazine Ad</MenuItem>
                        <MenuItem value="Dealer Showroom">
                          Dealer Showroom
                        </MenuItem>
                        <MenuItem value="Friend or Acquaintance">
                          Friend or Acquaintance
                        </MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                      {showError('survey')}
                    </Grid>
                    {surveyOption == 'Online Search' && (
                      <Grid item xs={12} md={6}>
                        <label>
                          Search term used?<sup>*</sup>
                        </label>
                        <TextField
                          type="text"
                          className="quote_re_form"
                          name="survey_details"
                          id="survey_details"
                          onChange={handleChange}
                          onBlur={handleError}
                        />
                        {showError('survey_details')}
                      </Grid>
                    )}
                    {surveyOption == 'Magazine Ad' && (
                      <Grid item xs={12} md={6}>
                        <label>
                          Which magazine?<sup>*</sup>
                        </label>
                        <TextField
                          type="text"
                          className="quote_re_form"
                          name="survey_details"
                          id="survey_details"
                          onChange={handleChange}
                          onBlur={handleError}
                        />
                        {showError('survey_details')}
                      </Grid>
                    )}
                    {surveyOption == 'Dealer Showroom' && (
                      <Grid item xs={12} md={6}>
                        <label>
                          Dealer name?<sup>*</sup>
                        </label>
                        <TextField
                          type="text"
                          className="quote_re_form"
                          name="survey_details"
                          id="survey_details"
                          onChange={handleChange}
                          onBlur={handleError}
                        />
                        {showError('survey_details')}
                      </Grid>
                    )}
                    {surveyOption == 'Other' && (
                      <Grid item xs={12} md={6}>
                        <label>
                          Please note<sup>*</sup>
                        </label>
                        <TextField
                          type="text"
                          className="quote_re_form"
                          name="survey_details"
                          id="survey_details"
                          onChange={handleChange}
                          onBlur={handleError}
                        />
                        {showError('survey_details')}
                      </Grid>
                    )}
                    <Grid item xs={12} className="FullwidthFLD">
                      <label>Comment box</label>
                      <textarea
                        className="quote_re_form"
                        name="comment"
                        id="comment"
                        onChange={handleChange}
                        minRows={6}
                      ></textarea>
                    </Grid>
                    <Grid item xs={12} md={6} className="required_note">
                      ( <sup>*</sup> Required fields)
                    </Grid>
                  </Grid>
                )}
              </Box>
            ) : (
              <Box className="TextCenter">
                <Typography className="SaveMsg">
                  Your request has been submitted. You&apos;ll receive a quote
                  soon.
                </Typography>
              </Box>
            )}
          </DialogContent>
          {!submit ? (
            <DialogActions className="ContentCenter">
              <Button variant="contained" onClick={handleClose}>
                Cancel
              </Button>
              <Button
                variant="contained"
                type="submit"
                className="request-quote-submit-btn"
                disabled={isSubmitting}
              >
                {!isSubmitting ? 'Submit' : 'Submitting...'}
              </Button>
            </DialogActions>
          ) : (
            <DialogActions className="ContentCenter">
              <Button
                variant="contained"
                className="request-quote-submit-btn"
                onClick={handleClose}
              >
                Ok
              </Button>
            </DialogActions>
          )}
        </form>
      </Dialog>
    </>
  );
};

RequestQuote.propTypes = {
  parentPath: PropTypes.string.isRequired,
};

export default RequestQuote;
